export const ContactSelectorTestIds = {
  CONTACT_SELECT: 'contact-selector.contact-select',
};
